export default () => {
  return {
    require: 'ngModel',
    link: function (scope, elem, attrs, ngModel) {
      if (attrs.type === 'number') {
        ngModel.$parsers.push((val) => `${val}`);
        ngModel.$formatters.push((value) => parseFloat(value));
      }
    },
  };
};
